import { ZhCn } from './zh.cn';
import { En } from './en';

export namespace I18N {
    export function factory() {
        const zhCn = ZhCn.factory();
        const en = En.factory();
        return {
            'zh-cn': zhCn,
            'en': en
        };
    }

    export function selectorFactory() {
        return [
            { key: 'en', value: 'English (US)' },
            { key: 'zh-cn', value: '中文 简体' },
        ];
    }

    export function ltypeToLocale(ltype: any) {
        return parseInt(ltype, 10) === 0 ? 'zh-cn' : 'en';
    }

    export enum EI18nLocale {
        Zn = 'zh-cn',
        En = 'en',
    }
}
